import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_59a092qk0m: FaireBrandEntity = {
  token: "b_59a092qk0m",
  type: "brand",
  name: "Goki America",
  avatarUrl:
    "https://cdn.faire.com/fastly/682c8033fe797addc9546fc45e962997c9c56cb06a455311119556a7e2b1e62c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/53da20550f2a58987c7bf71e026f17ac59089c1dd513940cec2ade768f573f02.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/682c8033fe797addc9546fc45e962997c9c56cb06a455311119556a7e2b1e62c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/53da20550f2a58987c7bf71e026f17ac59089c1dd513940cec2ade768f573f02.jpeg",
  location: "Charlotte, NC, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 20,
  isTopShop: true,
  isInsider: true,
  description:
    "For more than 40 years Goki has been bringing joyful to the child´s rooms. We put a lot of love, experience and responsibility into the development of toys for the young adventurers. If they are to help develop the encourage a child´s imagination and creativity, toys must have a high value.\n\nWe offer our own brands goki, goki evolutionand HOLZTIGER which stand for high-quality, sustainable and eco-friendly products. We design, development and manufacture award-winning toys and are happy to provide them here in the US.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:30.181Z",
    importedBy: "entity-db-cli",
  },
};
